import { Box, LinearProgress } from '@mui/material';
import { ProgressBarProps } from './ProgressBar.props';
import { Typography } from '../Typography';

export const ProgressBar = ({
  value = 0,
  showLabel = false,
  label,
  height,
  borderRadius,
  backgroundColor,
  variant = 'determinate',
  color = 'primary',
  sx,
  ...props
}: ProgressBarProps) => {
  // Ensure value is between 0 and 100
  const normalizedValue = Math.min(Math.max(value, 0), 100);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: 1,
      }}
    >
      <LinearProgress
        variant={variant}
        value={normalizedValue}
        color={color}
        sx={{
          flex: 1,
          ...(height && { height }),
          ...(borderRadius && {
            borderRadius: `${borderRadius}px`,
            '& .MuiLinearProgress-bar': {
              borderRadius: `${borderRadius}px`,
            },
          }),
          ...(backgroundColor && { backgroundColor }),
          ...sx,
        }}
        {...props}
      />
      {showLabel && (variant === 'determinate' || variant === 'buffer') && (
        <Typography
          sx={(theme) => ({
            ...theme.typography.M3.body.medium,
            minWidth: 33,
            textAlign: 'right',
            color: theme.palette.M3.sys.light['on-surface-variant'],
          })}
        >
          {label || `${Math.round(normalizedValue)}%`}
        </Typography>
      )}
    </Box>
  );
};

export default ProgressBar;
